import { AppContent } from '@/components/app-content';
import { AppShell } from '@/components/app-shell';
import { type BreadcrumbItem } from '@/types';
import { type PropsWithChildren, useEffect } from 'react';
import { AppHeader } from '@/components/app-header';
import { AppFooter } from '@/components/ui/app-footer';
import { usePage } from '@inertiajs/react';
import { toast, ToastContainer } from 'react-toastify';

export default function AppSidebarLayout({ children, breadcrumbs = [] }: PropsWithChildren<{ breadcrumbs?: BreadcrumbItem[] }>) {
    const {errors} = usePage().props

    useEffect(() => {
        if (errors.message) {
            toast.error(errors.message, {
                position: 'bottom-right',
                autoClose: 5000,
                className: "color: red"
            });
        }
    }, [errors])

    return (
        <AppShell variant="sidebar">
            <ToastContainer />

            {/*<AppSidebar />*/}
            <AppContent variant="header">
                <AppHeader breadcrumbs={breadcrumbs} />
                {/*<AppSidebarHeader breadcrumbs={breadcrumbs} />*/}
                <div className="min-h-screen" >{children}</div>
                <AppFooter />
            </AppContent>
        </AppShell>
    );
}
